import PropTypes from 'prop-types'
import { Box, IconButton, useMediaQuery, useTheme } from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
import { useAdminLayout } from './AdminLayoutContext'

/**
 * Header bar for admin pages. Shows a mobile menu toggle on small screens
 * and renders children in a space-between flex row.
 * @param {object} props
 * @param {React.ReactNode} props.children - Typically a title and action buttons
 */
const AdminPageHeader = ({ children }) => {
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'))
  const { toggleMobileSidebar } = useAdminLayout()

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
      {!isDesktop && (
        <IconButton
          onClick={toggleMobileSidebar}
          size="small"
          aria-label="open admin menu"
          sx={{ mr: 1 }}
        >
          <MenuIcon />
        </IconButton>
      )}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flex: 1,
        }}
      >
        {children}
      </Box>
    </Box>
  )
}

AdminPageHeader.propTypes = {
  children: PropTypes.node,
}

export default AdminPageHeader
